export default "__VITE_ASSET__24bab2ef__"